import { createAction } from '@reduxjs/toolkit';

const SHEETS_HISTORY_NAMESPACE = 'sheetsManager/history';

export const undoSheets = createAction(`${SHEETS_HISTORY_NAMESPACE}/undo`);
export const redoSheets = createAction(`${SHEETS_HISTORY_NAMESPACE}/redo`);
